import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { CamelToSentencePipe } from '@app/app/pipes/camel-to-sentence.pipe';

export const setFinanceAliasCol: (headerName: string) => ColDef = (headerName) => {
  headerName = CamelToSentencePipe.format(headerName);
  return {
    headerName,
    field: 'alias',
    flex: 1,
    valueFormatter: (params: ValueFormatterParams) => {
      return CamelToSentencePipe.format(params.value);
    }
  }
}
